module.exports = __webpack_public_path__ + "img/mod-3.470c0304.svg";